import { FiasDivision } from "../FiasWidgetTypes";
import { divisionType } from "../../../FiasInput/Types/FiasTypes";

export const convertDivisionType = (division: divisionType): FiasDivision => {
    if (division === "administrative") {
        return FiasDivision.Administrative;
    }

    return FiasDivision.Municipal;
};
